<template>
    <el-container>
        <el-header>
            <div class="head_container">
                <div class="head_placeholder" />
                <div class="head_logo">
                    <img src="@/assets/images/logo.png">
                    <span>{{ platformName }}</span>
                </div>
                <div class="head_menu" />
                <div class="right_menu">
                    <svg class="user_image" viewBox="64 64 896 896" focusable="false" data-icon="global" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                        <path d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z" />
                    </svg>
                    <span>{{ userInfo }}</span>
                    <el-button class="exit_button" icon="SwitchButton" type="primary" @click="logout()">退出</el-button>
                </div>
            </div>
        </el-header>
        <el-container class="main_container">
            <el-aside class="aside_container" width="180px">
                <el-menu unique-opened class="el-menu-vertical-demo" :background-color="'RGB(255, 255, 255)'" active-text-color="blue" :router="true">
                    <!-- 遍历菜单 -->
                    <template v-for="(item, index) in headMenuItemArray">
                        <!-- 第一层 含有子菜单 -->
                        <template v-if="item.children">
                            <el-sub-menu :index="(index+1)+''" :key="index+1">
                                <template #title>
                                    <el-icon v-if="item.icon">
                                        <component :is="item.icon" />
                                    </el-icon>
                                    <span>{{ item.title }}</span>
                                </template>
                                <template v-for="(subItem, subIndex) in item.children">
                                    <!-- 第二层 子菜单遍历 -->
                                    <el-sub-menu class="havaSubMenu" v-if="subItem.children.length>0" :index="index + '-' + (subIndex+1)" :key="index + '-' + (subIndex+1)">
                                        <template #title>
                                            <el-icon v-if="subItem.icon">
                                                <Link />
                                            </el-icon>
                                            <span>{{ subItem.title }}</span>
                                        </template>
                                        <!-- 第三层 子菜单遍历-->
                                        <el-menu-item v-for="(threeItem, i) in subItem.children" :key="i" :index="threeItem.path">
                                            <el-icon v-if="threeItem.icon">
                                                <component :is="threeItem.icon" />
                                            </el-icon>
                                            <template #title>
                                                <span>{{ threeItem.title }}</span>
                                            </template>
                                        </el-menu-item>
                                    </el-sub-menu>
                                    <!-- 第二层 不含子菜单 -->
                                    <el-menu-item class="noSubMenu" v-else :index="subItem.path" :key="subItem.path">
                                        <template #title>
                                            <div>
                                                <el-icon v-if="subItem.icon">
                                                    <component :is="subItem.icon" />
                                                </el-icon>
                                                <span>{{ subItem.title }}</span>
                                            </div>
                                        </template>
                                    </el-menu-item>
                                </template>
                            </el-sub-menu>
                        </template>
                        <!-- 第一层 不含子菜单  -->
                        <template v-else>
                            <el-menu-item :index="item.path" :key="item.path">
                                <el-icon>
                                    <Link />
                                </el-icon>
                                <template #title>
                                    <span>{{ item.title }}</span>
                                </template>
                            </el-menu-item>
                        </template>
                    </template>
                </el-menu>
            </el-aside>
            <el-container>
                <el-main>
                    <div id="el-tabs-div">
                        <el-tabs v-model="activeTabPath" type="card" @tab-click="clickTab" @tab-remove="removeTab">
                            <el-tab-pane v-for="item of openTab" :key="item.path" :label="item.title" :name="item.path" :closable="item.close" />
                        </el-tabs>
                        <div id="el-button-div">
                            <el-button class="tabs_close_button" icon="CircleClose" type="primary" round size="small" @click="removeAllTabPath" />
                        </div>
                    </div>

                    <div class="page_container">
                        <router-view v-slot="{ Component }">
                            <keep-alive :include="keepAlive">
                                <component :is="Component" :key="$route.fullPath" />
                            </keep-alive>
                        </router-view>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </el-container>
</template>

<script>
export default {
    name: 'Home',
    data () {
        return {
            platformName: '同擎体育管理系统',
            asideTitle: '解决方案',
            headMenuItemArray: [],
            asideItems: [],
            userRoleName: '',
            userName: '',
            userType: 1,
            activeIndex: '' // 当前tab选择项目的顺序号
        }
    },
    computed: {
        keepAlive () {
            const nameList = []
            this.$store.state.openTab.forEach(item => {
                nameList.push(item.name)
            })
            return nameList
        },
        userInfo () {
            // return '[' + this.userRoleName + '] ' + this.userName
            return this.userName
        },
        openTab () {
            return this.$store.state.openTab
        },
        activeTabPath: {
            get () {
                return this.$store.state.activeTabPath
            },
            set (val) {
                this.$store.commit('set_active_path', val)
            }
        }
    },
    watch: {
        '$route' (val) {
            let flag = false
            this.openTab.forEach(tab => {
                if (val.path === tab.path) {
                    this.$store.commit('set_active_path', val.path)
                    flag = true
                }
            })
            if (!flag) {
                // 监听需要替换的路由
                const needReplacePath = []
                if (needReplacePath.includes(val.path)) {
                    this.$router.replace({ path: val.path })
                    this.$store.commit('replace_tabs', { path: val.path, name: val.name, title: val.meta.title, close: 'closable', replace: needReplacePath })
                } else {
                    this.$store.commit('add_tabs', { path: val.path, name: val.name, title: val.meta.title, close: 'closable' })
                }
                this.$store.commit('set_active_path', val.path)
            }
        }
    },
    mounted () {
        this.getUserInfo()
        this.getMenu()
        this.$store.commit('clean_tabs', '')
        this.$router.replace({ path: '/dashboard' })
        this.$store.commit('add_tabs', { path: '/dashboard', name: 'dashboard', title: '数据概览' })
        this.$store.commit('set_active_path', '/dashboard')
        const pageSize = localStorage.getItem('page_size')
        if (pageSize !== null) {
            this.$store.commit('setPageSize', pageSize)
        }
    },
    methods: {
        clickTab (tab) {
            const path = tab.props?.name || tab.paneName
            if (path) {
                this.$router.replace({ path })
            }
        },
        // target当前被点击的name属性
        removeTab (target) {
            if (this.openTab.length === 1) {
                return
            }
            if (target === '/dashboard') {
                return
            }
            this.$store.commit('delete_tabs', target)
            if (this.activeTabPath === target) {
                // 设置当前激活的路由
                if (this.openTab && this.openTab.length >= 1) {
                    this.$store.commit('set_active_path', this.openTab[this.openTab.length - 1].path)
                    this.$router.replace({ path: this.activeTabPath })
                }
            }
        },
        logout () {
            this.$messageBox.confirm('您确定退出登录？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.replace('/login')
                this.$resetRouter()
                this.$store.commit('setIsAddRoutes', false)
                sessionStorage.removeItem('userInfo')
                sessionStorage.removeItem('userMenuList')
                this.$request.post(this.$apiUrl.logout, {})
            }).catch(() => { })
        },
        getUserInfo () {
            const sessionUserInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            this.userName = sessionUserInfo.userName
            this.userRoleName = sessionUserInfo.roleNames
            this.userType = sessionUserInfo.userRecord.userType
        },
        // 获取全部菜单
        getMenu () {
            this.headMenuItemArray = []
            const sessionUserMenuList = JSON.parse(sessionStorage.getItem('userMenuList'))
            this.analyzeMenuData(sessionUserMenuList, this.headMenuItemArray)
            this.displayAsideMenu(0)
        },
        // 递归查找菜单子节点
        analyzeMenuData (datas, arr) {
            const datasTemp = Array.from(datas)
            datasTemp.forEach((data, index) => {
                arr.push({
                    path: data.routePath,
                    name: data.menuName,
                    title: data.menuName,
                    icon: data.icon,
                    close: 'closable',
                    children: []
                })
                if (data.children) {
                    const childArr = this.analyzeMenuData(data.children, [])
                    arr[index].children = childArr
                }
            })
            return arr
        },
        // 显示子菜单 index为主菜单的顺序号
        displayAsideMenu (index) {
            const headMenuItem = this.headMenuItemArray[index]
            this.asideTitle = headMenuItem.name
            const asideItemsData = Array.from(headMenuItem.children)
            this.asideItems = []
            asideItemsData.forEach((data) => {
                this.asideItems.push({ path: data.path, name: data.name, title: data.name, close: 'closable' })
            })
        },
        removeAllTabPath () {
            this.$store.commit('clean_tabs', '')
            this.$router.replace({ path: '/dashboard' })
            this.$store.commit('add_tabs', { path: '/dashboard', name: 'dashboard', title: '数据概览' })
            this.$store.commit('set_active_path', '/dashboard')
        }
    }
}
</script>

<style lang="less" scoped>
.el-main {
    padding: 0px;
    background-color: #f7f7f9;
}
:deep(.el-tabs__header) {
    padding-left: 15px;
    margin: 0px;
}
:deep(.el-tabs) {
    margin-top: 6px;
    --el-tabs-header-height: 34px !important;
}
:deep(.el-tabs__item) {
    padding: 0 20px !important;
    height: 33px !important;
    line-height: 33px !important;
    color: #666666;
}
:deep(.el-tabs__nav) {
    border-radius: 0px 0px 0px 0px !important;
}

.el-tabs :deep(.is-active) {
    font-weight: 600;
    color: #22a06b;
    border-bottom-color: #f7f7f9 !important;
}
.el-tabs :deep(.el-tabs__item .is-icon-close) {
    overflow: visible !important;
    height: auto !important;
    min-width: 14px;
    display: inline-flex !important;
}
.el-tabs :deep(.el-tabs__item:hover) {
    color: #22a06b;
    cursor: pointer;
}

.page_container {
    position: absolute;
    left: 180px;
    top: 95px;
    right: 0px;
    bottom: 0px;
    overflow-y: auto;
    padding: 10px 12px 5px;
}
.subpage_container {
    padding: 15px;
}
.main_container {
    height: calc(100vh - 53px);
}
.aside_container {
    position: relative;
    margin: 0;
    box-shadow: 0 2px 8px 0 rgba(7, 12, 20, 0.12);
    background-color: white;
    .aside_head {
        color: rgba(0, 0, 0, 0.45);
        display: -ms-flexbox;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        padding: 0 16px 0 24px;
        border-bottom: 1px solid #bfc8d8;
        span {
            color: #212529;
            font-family: PingFangSC-Semibold;
            svg {
                color: rgba(0, 0, 0, 0.45);
                position: relative;
                top: 3px;
            }
        }
    }
    .el-menu {
        border-right: solid 0px #e6e6e6;
        margin-top: 5px;
    }
    :deep(li) {
        text-align: center;
        padding: 0px 0px 0px 0px !important;
        letter-spacing: 1px;
        .is-active {
            background-color: #22a06b !important;
            color: white !important;
            font-weight: 400;
        }
    }
    :deep(.el-sub-menu__title) {
        padding-left: 14px !important;
        font-size: 14px !important;
        text-align: left;
        height: 45px !important;
        line-height: 45px !important;
        color: #666666 !important;
    }
    .el-sub-menu.is-opened > .el-sub-menu__title span {
        color: #22a06b !important;
    }
    .el-sub-menu.is-opened > .el-sub-menu__title i {
        color: #22a06b !important;
    }
    :deep(.el-menu-item) {
        height: 36px;
        line-height: 36px;
        min-width: 100px;
        text-align: center;
        font-size: 14px;
        color: #666666 !important;
    }
}
.el-header {
    height: 53px !important;
    padding: 0px;
    box-sizing: border-box;
    flex-shrink: 0;
}
.head_container {
    display: flex;
    background: linear-gradient(135deg, #166d49 0%, #22a06b 100%);
    height: 52px;
    line-height: 52px;
    position: relative;
    .head_menu {
        color: white;
        display: inline;
        height: 52px;
        flex-grow: 1;
        justify-content: center;
        .head_menuitem {
            width: 70px;
            cursor: pointer;
            margin-right: 35px;
        }
        .head_menuitem:hover {
            color: #87d8b1;
        }
        .head_menuitem:after {
            width: 16px;
            height: 16px;
            margin-top: 24px;
            background: url(../assets/images/menu_item_after.svg) no-repeat;
            content: "";
            position: absolute;
        }
    }
    .right_menu {
        width: 330px !important;
        text-align: right;
        img {
            width: 18px;
            position: relative;
            top: 4px;
        }
        span {
            color: #fefefe;
            margin-left: 7px;
            margin-right: 19px;
        }
        .user_image {
            color: #fefefe;
            width: 14px;
            position: relative;
            top: 3px;
        }
        .head_search {
            width: 210px;
            height: 36px;
            background-color: rgba(255, 255, 255, 0.1);
            display: inline-block;
            position: relative;
            top: 12px;
            right: 20px;
            border-radius: 4px;
            :deep(.el-input__inner) {
                height: 35px !important;
                padding: 0px 0px 0px 8px;
                border: 1px solid rgba(0, 0, 0, 0);
                border-radius: 4px;
                background-color: hsla(0, 0%, 100%, 0);
                width: 180px;
                color: #fff;
                position: relative;
                top: -13px;
                left: -29px;
            }
            :deep(.el-input__inner:focus) {
                outline: 0;
                border: 0px solid #22a06b;
            }
            span {
                position: absolute;
                left: 182px;
                top: -9px;
            }
        }
    }
    .exit_button {
        height: 35px;
        border: none;
        background-color: rgba(34, 160, 107, 0.85);
        color: #ffffff;
        font-size: 13px;
        margin-right: 12px;
        border-radius: 4px;
    }
    .exit_button:hover {
        background-color: rgba(34, 160, 107, 1);
        color: #ffffff;
    }
    .exit_button:active {
        background-color: rgba(27, 128, 86, 1);
        color: #ffffff;
    }
}
.head_placeholder {
    width: 15px;
}
.head_logo {
    color: #22a06b;
    margin-top: 7px;
    width: 400px !important;
    img {
        width: 27px;
        position: relative;
    }
    span {
        position: relative;
        top: -6px;
        left: 10px;
        font-family: 微软雅黑;
        font-size: 17px;
        color: white;
        letter-spacing: 1px;
    }
}
:deep(.havaSubMenu > .el-sub-menu__title) {
    padding-left: 20px !important;
}
:deep(.noSubMenu > div) {
    margin: 0 auto;
}
:deep(.noSubMenu > span) {
    padding-left: 0px !important;
    position: relative;
    left: -4px;
}
#el-tabs-div {
    display: flex;
    .el-tabs {
        flex-grow: 1;
        width: 100px;
    }
    #el-button-div {
        width: 55px;
        line-height: 38.6px;
        text-align: center;
        border-bottom: 1px solid #dcdfe6;
        .tabs_close_button {
            margin-left: 0px;
            padding: 4px 7px;
            background-color: #b83227;
            border-width: 0px;
        }
        .tabs_close_button:hover {
            background-color: #a02c22;
        }
    }
}
:deep(.el-tabs__nav-prev) {
    line-height: 34px;
}
:deep(.el-tabs__nav-next) {
    line-height: 34px;
}
</style>
